import "$styles/index.css"

function gridCellDimensions() {
  const element = document.createElement("div");
  element.style.position = "fixed";
  element.style.height = "var(--line-height)";
  element.style.width = "1ch";
  document.body.appendChild(element);
  const rect = element.getBoundingClientRect();
  document.body.removeChild(element);
  return { width: rect.width, height: rect.height };
}

// Add padding to each media to maintain grid.
function adjustMediaPadding() {
  const cell = gridCellDimensions();

  function setHeightFromRatio(media, ratio) {
      const rect = media.getBoundingClientRect();
      const realHeight = rect.width / ratio;
      const diff = cell.height - (realHeight % cell.height);
      media.style.setProperty("padding-bottom", `${diff}px`);
  }

  function setFallbackHeight(media) {
      const rect = media.getBoundingClientRect();
      const height = Math.round((rect.width / 2) / cell.height) * cell.height;
      media.style.setProperty("height", `${height}px`);
  }

  function onMediaLoaded(media) {
    var width, height;
    switch (media.tagName) {
      case "IMG":
        width = media.naturalWidth;
        height = media.naturalHeight;
        break;
      case "VIDEO":
        width = media.videoWidth;
        height = media.videoHeight;
        break;
    }
    if (width > 0 && height > 0) {
      setHeightFromRatio(media, width / height);
    } else {
      setFallbackHeight(media);
    }
  }

  const medias = document.querySelectorAll("img, video");
  for (media of medias) {
    switch (media.tagName) {
      case "IMG":
        if (media.complete) {
          onMediaLoaded(media);
        } else {
          media.addEventListener("load", () => onMediaLoaded(media));
          media.addEventListener("error", function() {
              setFallbackHeight(media);
          });
        }
        break;
      case "VIDEO":
        switch (media.readyState) {
          case HTMLMediaElement.HAVE_CURRENT_DATA:
          case HTMLMediaElement.HAVE_FUTURE_DATA:
          case HTMLMediaElement.HAVE_ENOUGH_DATA:
            onMediaLoaded(media);
            break;
          default:
            media.addEventListener("loadeddata", () => onMediaLoaded(media));
            media.addEventListener("error", function() {
              setFallbackHeight(media);
            });
            break;
        }
        break;
    }
  }
}

adjustMediaPadding();
window.addEventListener("load", adjustMediaPadding);
window.addEventListener("resize", adjustMediaPadding);

function checkOffsets() {
  const ignoredTagNames = new Set([
    "THEAD",
    "TBODY",
    "TFOOT",
    "TR",
    "TD",
    "TH",
  ]);
  const cell = gridCellDimensions();
  const elements = document.querySelectorAll("body :not(.debug-grid, .debug-toggle)");
  for (const element of elements) {
    if (ignoredTagNames.has(element.tagName)) {
      continue;
    }
    const rect = element.getBoundingClientRect();
    if (rect.width === 0 && rect.height === 0) {
      continue;
    }
    const top = rect.top + window.scrollY;
    const left = rect.left + window.scrollX;
    const offset = top % (cell.height / 2);
    if(offset > 0) {
      element.classList.add("off-grid");
      console.error("Incorrect vertical offset for", element, "with remainder", top % cell.height, "when expecting divisible by", cell.height / 2);
    } else {
      element.classList.remove("off-grid");
    }
  }
}

const debugToggle = document.querySelector(".debug-toggle");
function onDebugToggle() {
  if (debugToggle) {
    document.body.classList.toggle("debug", debugToggle.checked);
  }
}
if (debugToggle) {
  debugToggle.addEventListener("change", onDebugToggle);
  onDebugToggle();
}

// Анимация перехода символов голов (State Machine + Weighted Random)
function animateHeads() {
  // Находим div с классом rotating-heads
  const container = document.querySelector(".rotating-heads");
  if (!container) return;

  // Массив символов голов
  const headSymbols = ["𜱚", "𜱛", "𜱜"];
  // Массив символов ног для случайного выбора
  const footSymbols = ["𜱝", "𜱞", "𜱟"];

  // Функция для случайного выбора символа ноги
  function getRandomFoot() {
    return footSymbols[Math.floor(Math.random() * footSymbols.length)];
  }

  // Исходная структура из markdown (160-162 строки)
  // 𜱚          𜱛          𜱜
  // 𜱝          𜱝          𜱝 (случайно выбираются из 𜱝, 𜱞, 𜱟)
  // ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
  const lines = [
    ["𜱚", "          ", "𜱛", "          ", "𜱜"],
    [getRandomFoot(), "          ", getRandomFoot(), "          ", getRandomFoot()],
    ["░░░░░░░░░░░░░░░░░░░░░░░░░░░░░"]
  ];

  // Создаем новую структуру динамически
  let newContent = "";

  for (let lineIndex = 0; lineIndex < lines.length; lineIndex++) {
    const line = lines[lineIndex];

    for (let i = 0; i < line.length; i++) {
      const char = line[i];

      // Если это символ головы, оборачиваем в span
      if (headSymbols.includes(char)) {
        const symbolIndex = headSymbols.indexOf(char);
        newContent += `<span class="animated-head" data-index="${symbolIndex}">${char}</span>`;
      } else {
        // Для ног и пробелов - обычный текст
        newContent += char;
      }
    }

    // Добавляем перенос строки (кроме последней строки)
    if (lineIndex < lines.length - 1) {
      newContent += "\n";
    }
  }

  // Создаем pre элемент для сохранения моноширинной верстки
  const pre = document.createElement("pre");
  pre.innerHTML = newContent;

  // Очищаем контейнер и добавляем pre
  container.innerHTML = "";
  container.appendChild(pre);

  // Находим все анимированные головы
  const heads = pre.querySelectorAll(".animated-head");

  // Функция для выбора следующего индекса с учетом весов
  function getNextIndex(currentIndex) {
    const random = Math.random();

    let direction;
    let steps;

    // Выбираем направление с весами: вперед 50%, назад 30%, частичный поворот 20%
    if (random < 0.5) {
      // Вперед: 1-5 шагов
      direction = 1;
      steps = Math.floor(Math.random() * 5) + 1;
    } else if (random < 0.8) {
      // Назад: 1-5 шагов
      direction = -1;
      steps = Math.floor(Math.random() * 5) + 1;
    } else {
      // Частичный поворот: строго 1 шаг, случайное направление
      direction = Math.random() < 0.5 ? 1 : -1;
      steps = 1;
    }

    // Вычисляем новый индекс
    let newIndex = currentIndex + (direction * steps);

    // Ограничиваем границами массива (0-2)
    if (newIndex < 0) {
      newIndex = 0;
    } else if (newIndex >= headSymbols.length) {
      newIndex = headSymbols.length - 1;
    }

    return newIndex;
  }

  // Функция для обновления символа
  function updateHead(head) {
    const currentIndex = parseInt(head.getAttribute("data-index"));
    const newIndex = getNextIndex(currentIndex);

    // Обновляем символ и индекс
    head.textContent = headSymbols[newIndex];
    head.setAttribute("data-index", newIndex);

    // Планируем следующий переход с случайной задержкой (1-3 секунды)
    const delay = 1000 + Math.random() * 2000;
    setTimeout(() => updateHead(head), delay);
  }

  // Запускаем анимацию для каждой головы с разной начальной задержкой
  heads.forEach((head, index) => {
    const initialDelay = Math.random() * 2000; // Начальная задержка 0-2 секунды
    setTimeout(() => {
      updateHead(head);
    }, initialDelay);
  });
}

// Запускаем анимацию после загрузки страницы
window.addEventListener("load", animateHeads);
// Также запускаем сразу на случай, если DOM уже готов
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", animateHeads);
} else {
  animateHeads();
}

// Инициализация карусели
function initCarousel() {
  const carousels = document.querySelectorAll(".carousel");
  if (carousels.length === 0) return;

  carousels.forEach((carousel) => {
    const items = Array.from(carousel.querySelectorAll(".carousel-item"));
    if (items.length <= 1) return; // Не нужна карусель для одного элемента

    // Оборачиваем карусель в wrapper
    const wrapper = document.createElement("div");
    wrapper.className = "carousel-wrapper";
    carousel.parentNode.insertBefore(wrapper, carousel);
    wrapper.appendChild(carousel);

    // Создаем контейнер для элементов
    const itemsContainer = document.createElement("div");
    itemsContainer.className = "carousel-items";

    // Перемещаем элементы в контейнер и оборачиваем контент
    items.forEach((item) => {
      // Создаем внутренний контейнер для контента
      const contentWrapper = document.createElement("div");
      contentWrapper.className = "carousel-item-content";
      // Перемещаем весь контент из item в contentWrapper
      while (item.firstChild) {
        contentWrapper.appendChild(item.firstChild);
      }
      // Добавляем contentWrapper обратно в item
      item.appendChild(contentWrapper);
      itemsContainer.appendChild(item);
    });

    // Очищаем carousel и добавляем контейнер
    carousel.innerHTML = "";
    carousel.appendChild(itemsContainer);

    // Создаем кнопки навигации
    const prevButton = document.createElement("button");
    prevButton.className = "carousel-button carousel-button-prev";
    prevButton.textContent = "←";
    prevButton.setAttribute("aria-label", "Previous");

    const nextButton = document.createElement("button");
    nextButton.className = "carousel-button carousel-button-next";
    nextButton.textContent = "→";
    nextButton.setAttribute("aria-label", "Next");

    // Создаем точки навигации
    const dotsContainer = document.createElement("div");
    dotsContainer.className = "carousel-dots";

    const dots = [];
    items.forEach((_, index) => {
      const dot = document.createElement("button");
      dot.className = "carousel-dot" + (index === 0 ? " active" : "");
      dot.setAttribute("aria-label", `Go to slide ${index + 1}`);
      dotsContainer.appendChild(dot);
      dots.push(dot);
    });

    // Добавляем навигацию в wrapper (не в carousel!)
    wrapper.appendChild(prevButton);
    wrapper.appendChild(nextButton);
    wrapper.appendChild(dotsContainer);

    let currentIndex = 0;

    function updateCarousel() {
      const translateX = -currentIndex * 100;
      itemsContainer.style.transform = `translateX(${translateX}%)`;

      // Обновляем активную точку
      dots.forEach((dot, index) => {
        dot.classList.toggle("active", index === currentIndex);
      });
    }

    function goToSlide(index) {
      if (index < 0) index = items.length - 1;
      if (index >= items.length) index = 0;
      currentIndex = index;
      updateCarousel();
    }

    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    function prevSlide() {
      goToSlide(currentIndex - 1);
    }

    // Обработчики событий
    nextButton.addEventListener("click", nextSlide);
    prevButton.addEventListener("click", prevSlide);

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => goToSlide(index));
    });

    // Клавиатурная навигация
    wrapper.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") {
        prevSlide();
      } else if (e.key === "ArrowRight") {
        nextSlide();
      }
    });

    // Инициализация
    updateCarousel();
  });
}

// Запускаем инициализацию карусели после загрузки DOM
document.addEventListener("DOMContentLoaded", initCarousel);
// Также запускаем сразу на случай, если DOM уже готов
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCarousel);
} else {
  initCarousel();
}
